import {applyMiddleware, compose, createStore} from 'redux';
import thunk from 'redux-thunk';
import reducers from '../reducers';
import {firebase, fsVersion} from "../firestore";
import {addToast, PLAY_SCREEN} from '../ducks/duck-screen'
import middlewareRouter from '../middleware/middleware-router';
import middlewareErrorHandler from '../middleware/middleware-error-handler';
import {createBrowserHistory} from 'history';
import {initHistoryListener} from '../helpers/listeners/history-listener';
import {fetchFsConfig} from "../ducks/duck-config";
import {fetchGameTypeLevelsProperties} from "../ducks/duck-game";
import {
	fsLoginUserAnonymously,
	initializeUserState,
	setDidUserDeleteAccount,
	setIsAnonymousUserFlag
} from "../ducks/duck-user";
import {createLocationListener, getPath} from "../helpers/listeners/location-listener";
import {logger} from "../helpers/console-logger";


// Create the history object
const history = createBrowserHistory();

// Build the middleware
const middleware = middlewareRouter(history);

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
let store = createStore(reducers, composeEnhancers(applyMiddleware(middleware, thunk, middlewareErrorHandler)));
// store.dispatch(initializeFirestoreLevelList());

firebase.auth().onAuthStateChanged(function(user) {
	if (user) {
		if(store.getState().userReducer.didDeleteAccount){
			store.dispatch(addToast('toast_login_deleted_account'));
			store.dispatch(setDidUserDeleteAccount(false))
		}else if(user.isAnonymous){
			store.dispatch(addToast('toast_login_welcome_anonymous'));
		} else {
			let name = user.displayName || user.email || "";
			if(name === user.email){
				name = name.replace(/(@.+)/g, "")
			}
			store.dispatch(addToast('toast_login_welcome_user', 5000, [name]));
		}
		store.dispatch(setIsAnonymousUserFlag(user.isAnonymous));

		store.dispatch(initializeUserState(user));

		fsVersion.collection("users").doc(user.uid).update({
			lastSignInDate: new Date(Date.now())
		})
			.catch(error => {
				// console.log("Nie udało sie podbić lastSignInDate");
				// console.log(error);
			})
	} else {
		store.dispatch(fsLoginUserAnonymously())
	}
});

firebase.auth().getRedirectResult()
	.catch(error => {
		debugger
		if(error.code === "auth/account-exists-with-different-credential"){
			store.dispatch(addToast("toast_login_credentials_exist", 10000))
		}
	});


store.dispatch(fetchFsConfig());
store.dispatch(fetchGameTypeLevelsProperties());
// store.dispatch(fsLoginUserTest());

initHistoryListener(history, store);
const locationListener = createLocationListener(store);
store.subscribe(locationListener);

if(process.env.NODE_ENV === "development" && history.location.pathname !== "/levels"){
	history.replace(getPath(""));
}


if(history.location.pathname.endsWith("/levels")){
	history.replace(getPath(""));
	history.push(PLAY_SCREEN)
}

if (module.hot) {
	// Enable Webpack hot module replacement for reducers
	module.hot.accept('../reducers', () => {
		const nextRootReducer = require('../reducers').default;
		store.replaceReducer(nextRootReducer);
	});
}

window.originalLog = window.console.log;
window.console.log = logger.log;

export default store